/**
 * 利润/毛利率统计口径：合并应收+应付明细
 * 商务特殊费用（仅应付侧、金额可负）明细行照常显示，但不参与利润类统计
 */
export function mergeChargesForProfitTotal(arCharges, apCharges) {
  const results = []
  for (const charge of arCharges || []) {
    results.push(charge)
  }
  for (const charge of apCharges || []) {
    if (!charge.businessSpecial) {
      results.push(charge)
    }
  }
  return results
}
